import { ApiError } from './client';

export function uploadErrorMessageKey(cause: unknown, fallbackKey = 'files.upload.failed'): string {
  if (cause instanceof ApiError) {
    switch (cause.code) {
      case 'request_too_large':
      case 'chunk_too_large':
      case 'file_too_large':
        return 'files.upload.tooLarge';
      case 'guest_upload_file_limit':
        return 'files.guest.uploadFileLimit';
      case 'guest_upload_byte_limit':
        return 'files.guest.uploadByteLimit';
      case 'reply_budget_exhausted':
        return 'errors.replyBudgetExhausted';
      default:
        break;
    }
  }

  return fallbackKey;
}
